import { CanvasJSChart } from 'canvasjs-react-charts'
import * as R from 'ramda';
import React, { useEffect, useState } from 'react';

function LineChart({ title, xTitle, yTitle, toolTipContent, dataPoints, extractX, extractY }) {
	const [processedPoints, setProcessedPoints] = useState([]);

	useEffect(() => {
		let processedPoints = R.map(dataPoint => ({ x: extractX(dataPoint), y: extractY(dataPoint )}))(dataPoints);
		setProcessedPoints(processedPoints);
	}, [dataPoints]);

	const options = {
		animationEnabled: true,
		exportEnabled: true,
		theme: "light2", // "light1", "dark1", "dark2"
		title:{
			text: title
		},
		axisY: {
			title: xTitle.title,
		},
		axisX: {
			title: yTitle.title,
			interval: 1
		},
		data: [{
			type: "line",
			toolTipContent: toolTipContent,
			dataPoints: processedPoints
		}]
	}
	return (
		<div>
			<CanvasJSChart options = {options}/>
		</div>
	);
}
export default LineChart;